import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AddCardComponent } from "./add-card.component";


@NgModule({
  declarations: [
      AddCardComponent
  ],
  exports:[
AddCardComponent
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
  
  ],
  providers: [
   
  ],
  
})
export class AddCardModule {}
